<template>
    <div class="rule-list">
        <status-tabs :status.sync="status" :statusList="statusList" :funcName="funcName"></status-tabs>

        <search-tool ref="searchTool" :status="status" :statusList="statusList" :funcName="funcName"
            :searchForm="searchForm" :searchList="searchList" :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields" listName="transactionDetails" :loading="loading"
            :menuAuth="menuAuth" inputPlaceholder="Keywords include Rule Name、Shipping Methods"></search-tool>

        <div class="table" :style="{ height: `calc(${height} + 40px)` }">
            <el-table :data="tableData" ref="tableData" height="100%" row-key="id"
                @selection-change="handleSelectionChange">
                <!-- <el-table-column type="selection" align="center"></el-table-column> -->
                <el-table-column align="left" label="ID" prop="id"></el-table-column>
                <el-table-column align="left" label="Rule Name" prop="name"></el-table-column>
                <el-table-column align="left" label="Shipping Methods" prop="last_mile_name"></el-table-column>
                <el-table-column align="left" label="Status" prop="status">
                    <div slot-scope="scope">
                        <el-switch
                        class="switcher"
                            v-model="scope.row.status"
                            :disabled="saving > 0"
                            :active-value="1"
                            :inactive-value="2"
                            active-text="ON"
                            inactive-text="OFF"
                            @change="changeStatus(scope.row)"
                            >
                        </el-switch>
                        <div v-show="saving === scope.row.id">Updating...</div>
                    </div>
                </el-table-column>
                <el-table-column align="left" label="Create Time" prop="created_at"></el-table-column>
                <el-table-column align="left" label="Update Time" prop="updated_at"></el-table-column>
                <el-table-column label="Operation" align="left" width="150">
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination :paginationData="paginationData" @paginationChange="paginationChange" :funcName="funcName">
        </pagination>
        <shippingRuleForm :shippingRuleFormVisible.sync="shippingRuleFormVisible" :countries="countries" :shops="advanceSearchFields.shop.options" :funcName="funcName" :tableItem="tableItem"></shippingRuleForm>
        <shippingRuleDetail :shippingRuleDetailVisible.sync="shippingRuleDetailVisible" :countries="countries" :shops="advanceSearchFields.shop.options" :tableItem="tableItem"></shippingRuleDetail>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import { mapActions } from "vuex";
import shippingRuleForm from "./shippingRules/shippingRuleForm.vue";
import shippingRuleDetail from "./shippingRules/shippingRuleDetail.vue";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            tableItem: {
                name: '',
                country: [],
                weight_min: '',
                weight_max: '',
                last_mile: '',
                shop: [],
            },
            searchForm: {
                country: ["", ""],
                shop: "",
                weight: ["", ""],
            },
            searchForm_transfer: {
                country: ["", ""],
                shop: "",
                weight: ["", ""],
            },
            funcName: "shippingRules",
            selectList: [],
            shippingRuleFormVisible: false,
            shippingRuleDetailVisible: false,
            editVisible: false,
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [{label: 'Open', value: '1'}, {label: 'Close', value: '2'}],
                },
                country: {
                    label: "Country",
                    type: "select",
                    options: [],
                },
                shop: {
                    label: "Store",
                    type: "select",
                    options: [],
                },
                weight: {
                    label: "Weight",
                    type: "range",
                },
            },
            countries: [],
            saving: 0
        };
    },
    methods: {
        ...mapActions(["getCountrySelect", "shopSelect"]),
        add() {
            this.tableItem = {
                name: '',
                country: [],
                weight_min: '',
                weight_max: '',
                last_mile: '',
                shop: [],
            }
            this.shippingRuleFormVisible = true;
        },
        shippingRules(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .shippingRule(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data.map(item => {
                            item.authority[2].delTitle = 'It means deleting all settings of this rule, but it will not affect orders that already existed CMOffer,Sure to delete?'
                            item.authority[2].cancelButtonText = 'Cancel'
                            item.authority[2].confirmButtonText = 'Delete'
                            if (item.status === 1) {
                                item.authority[2].disabled = true
                            }
                            return item;
                        });
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        changeStatus(row) {
            this.saving = row.id
            cmofferApi
                .shippingRule(
                    row,
                    "put",
                    row.id
                )
                .then((res) => {
                    if (res && res.errcode === 0) {
                        this.$message.success('Success');
                        this[this.funcName]();
                    } else {
                        row.status = row.status === 1 && 2 || 1
                        this.$message.error(res.errmsg)
                    }
                }).finally(() => this.saving = 0);
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "edit") {
                    this.shippingRuleFormVisible = true;
                } else if (item.funcName == "detail") {
                    this.shippingRuleDetailVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi.shippingRule(
                        {},
                        "delete",
                        row.id
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this.shippingRules(1);
                        }
                    });
                }
            }
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        // handleSelectionChange(val) {
        //     this.selectList = [];
        //     for (let i in val) {
        //         this.selectList.push(val[i].id);
        //     }
        // },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.shippingRules();
            this.getCountrySelect().then((res) => {
                const countryList = res.data.map(item => ({ label: item.name_en, value: item.id.toString() }))
                this.searchList.find(s => s.key === 'country').props.list = countryList
                this.advanceSearchFields.country.options = countryList
                this.countries = countryList
            })
            this.shopSelect().then((res) => {
                const shopList = res.data.filter(item => ![1,2,5,6].includes(item.platform_id)).map(item => ({ label: item.name, value: item.id.toString(), platform_id: item.platform_id }))
                this.searchList.find(s => s.key === 'shop').props.list = shopList
                this.advanceSearchFields.shop.options = shopList
            })
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        shippingRuleForm,
        shippingRuleDetail,
    },
    computed: {
        searchList() {
            return [
                {
                    label: "Weight",
                    key: "weight",
                    type: "range",
                },
                {
                    label: "Country",
                    key: "country",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "country",
                    },
                },
                {
                    label: "Store",
                    key: "shop",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "shop",
                    },
                },
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.rule-list {
    width: 100%;
    height: 100%;
    background: #fff;

    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);

        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }

        .switcher {
            .el-switch__label--left {
                position: absolute;
                right: 0;
                margin-right: 2px;
                color: #fff;
                z-index: 1;
                display: none;

                &.is-active {
                    display: block;
                }

                span {
                    transform: scale(0.8);
                }
            }
            .el-switch__label--right {
                position: absolute;
                left: 0;
                margin-left: 2px;
                color: #fff;
                display: none;

                &.is-active {
                    display: block;
                }

                span {
                    transform: scale(0.8);
                }
            }
        }

        .el-button--mini{
            &.warnning {
                color: #f90;
            }
            &.danger {
                color: #f00;
                &.is-disabled {
                    color: #999;
                }
            }
        }
    }
}
</style>
